<template>
  <div
    class="px-10 min-h-[calc(100vh_-_90px)] sm:min-h-[calc(100vh_-_90px)] overflow-x-hidden bg-white"
  >
    <div
      class="container max-w-[1200px] mx-auto flex flex-wrap items-center sm:min-h-[calc(100vh_-_90px)]"
    >
      <div class="py-10 w-full md:w-1/2 h-full">
        <div class="bg-chateauGreen-100 h-full flex items-center justify-center rounded-3xl">
          <img src="/img/excel-analyst-application-screen-concept-10008900-8162164.webp" alt="excel analyst application screen concept" width="545" height="450" />
        </div>
      </div>
      <div class="py-10 w-full md:w-1/2 px-10">
        <h1 class="text-3xl sm:text-5xl/[60px] font-bold mt-2 mb-5">
          Unlock the Full Potential of Your CSV Data
        </h1>
        <p class="text-xl text-alto-500">
          Transform your static CSV files into a dynamic RAG application for effortless searching and collaboration
        </p>
        <ul class="list-disc ml-5 my-5">
          <li class="mb-2">Seamlessly upload your CSV files and choose which columns should be searchable</li>
          <li class="mb-2">Experience vector-based similarity search to pinpoint exactly what you need for Retrieval-Augmented Generation</li>
          <li class="mb-2">Utilize intuitive chat features for real-time chat with your CSV data</li>
          <li class="mb-2">Trust in robust security measures to keep your data protected at all times</li>
        </ul>
        <div class="flex flex-wrap">
          <router-link
            class="mt-5 mr-5 w-full sm:w-auto cursor-pointer"
            to="/"
          >
            <button
              aria-label="Use CSV RAG to transform your CSV files into a dynamic RAG application"
              class="uppercase text-sm bg-chateauGreen px-5 py-3 rounded-lg text-white"
            >
              Start Transforming Your Data
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      webBaseUrl: import.meta.env.VITE_WEB_BASE_URL,
    };
  },
  mounted() {
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>
